var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.live!=null)?_c('footer',{style:(_vm.live.live.footer.styles)},[_c('p',{staticClass:"textFooter mb-0 text-center"},[_vm._v(" "+_vm._s(_vm.live.live.footer.texts[("" + _vm.lang)])+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }